module.exports = __webpack_public_path__ + "img/vip_head.e3979049.png";